/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Custom_IntegrationsInputs */

const en_landing_pricing_feature_custom_integrations = /** @type {(inputs: Landing_Pricing_Feature_Custom_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom integrations`)
};

const zh_landing_pricing_feature_custom_integrations = /** @type {(inputs: Landing_Pricing_Feature_Custom_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定制集成`)
};

/**
* | output |
* | --- |
* | "Custom integrations" |
*
* @param {Landing_Pricing_Feature_Custom_IntegrationsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_custom_integrations = /** @type {((inputs?: Landing_Pricing_Feature_Custom_IntegrationsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Custom_IntegrationsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_custom_integrations(inputs)
	return zh_landing_pricing_feature_custom_integrations(inputs)
});
export { landing_pricing_feature_custom_integrations as "landing.pricing.feature_custom_integrations" }